import React from 'react';
import { useSelector } from 'react-redux';

import {
  getFieldKey,
  fieldShouldDisplay,
} from '../../../../utils/form';

import FormLabel from './FormLabel';

function TextBlock({
  cols = '12',
  className,
  name,
  textOverride,
}) {

  const {
    values,
    form: { form },
  } = useSelector(store => store);
  const customLabel = getFieldKey(form, name, 'label');
  const defaultLabel = useSelector(store => store.labels[name]);

  // if field doesn't exist or is conditionally hidden, don't show it.
  // Unless we have a text Override, then that overrides existance in config
  // and conditionaly display logic
  if (!fieldShouldDisplay(form, name, values) && !textOverride) return null;

  return (
    <div className={`col-md-${cols} ${className}`}>
      <p>
        <FormLabel name={name} label={textOverride || customLabel || defaultLabel} />
      </p>
    </div>
  );
}

export default TextBlock;
